import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { CategoryModal } from 'components/Modal/CategoryModal'
import { Modal } from 'components/Modal/Modal'
import { NavBar } from 'components/NavBar/NavBar'
import { Button } from 'components/ui/Button/Button'
import { BackHeader } from 'components/ui/BackHeader/BackHeader'
import { useSelector } from 'react-redux'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { EditIcon } from 'assets/icons/EditIcon'
import { RootState } from 'store'
import { cleanSingleClientMachine } from 'features/clientMachinery/clientMachinerySlice'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { getMachineryCategories } from 'features/categories/machineryCategories'
import { ModalTypes } from 'types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'
import { getMachineCategoryIcon } from 'pages/Machinery/machineCategoryIcons'
import { tokens } from 'styling/tokens'
import {
  CategoryGrid,
  CategoryCard,
  CategoryLeft,
  CategoryIcon,
  CategoryName,
  EditBtn,
} from './FleetCategories.styled'

export const FleetCategories = () => {
  const { machineryCategories, totalMachineryPages } = useSelector(
    (store: RootState) => store.machineryCategories,
  )
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))

  const [modal, setModal] = useState<any>({
    open: false,
    edit: true,
    text: '',
    id: '',
    iconName: null,
    fields: [],
  })

  const ToggleEditModal = (text, id, iconName) => {
    setModal({ open: true, edit: true, text, id, iconName })
  }

  const ToggleAddModal = () => {
    setModal({ open: true, edit: false, text: '', id: '', iconName: null })
  }

  useQueryPagination({
    fetchFunctions: [getMachineryCategories],
    cleanUpFunctions: [cleanSingleClientMachine],
    params,
  })

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Categories...' setParams={setParams} />
      <PageWrapper>
        <BackHeader title='Categories' backTo='/machinery/fleet'>
          <Button variant='secondary' onClick={() => navigate('/machinery/add')}>
            Add Machinery
          </Button>
          <Button variant='primary' onClick={ToggleAddModal}>
            Add Category
          </Button>
        </BackHeader>

        {!machineryCategories.length ? (
          <NoItems title='Categories' />
        ) : (
          <CategoryGrid>
            {machineryCategories.map((category) => {
              const { name, id, iconName } = category
              return (
                <CategoryCard
                  key={id}
                  onClick={() => navigate('/machinery/' + id.toString() + '?name=' + name)}
                >
                  <CategoryLeft>
                    <CategoryIcon>
                      {getMachineCategoryIcon(iconName, tokens.accent.base, 18)}
                    </CategoryIcon>
                    <CategoryName>{name}</CategoryName>
                  </CategoryLeft>
                  <EditBtn
                    type='button'
                    aria-label='Edit category'
                    onClick={(e) => {
                      e.stopPropagation()
                      ToggleEditModal(name, id, iconName)
                    }}
                  >
                    <EditIcon />
                  </EditBtn>
                </CategoryCard>
              )
            })}
          </CategoryGrid>
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalMachineryPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>

      {modal.open && (
        <Modal black>
          <CategoryModal
            machinery
            text={modal.text}
            edit={modal.edit}
            id={modal.id}
            iconName={modal.iconName}
            setParams={{
              type: ModalTypes.Delete,
              f: setParams,
              noItems: machineryCategories.length < 2,
            }}
            close={setModal}
          />
        </Modal>
      )}
    </>
  )
}
